import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col } from "react-bootstrap";

const Cancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8} className="text-center">
          <h1 className="h4 mb-2">Payment canceled</h1>
          <p className="text-muted mb-4">
            Your payment did not go through.
          </p>

          {/* Stacks on mobile, inline and centered on sm+ */}
          <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
            <Button
              variant="primary"
              size="lg"
              onClick={() => navigate("/products")}
            >
              Continue Shopping
            </Button>

            <Button
              variant="outline-secondary"
              size="lg"
              onClick={() => navigate("/account")}
            >
              My Account
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Cancel;
